import React from "react";
import {TextField} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const HelpFields = (props) => {
    const { textLabel, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.text);

        onSync(modified);
    }

    return <div className="help-fields">
        <div className="field top-margin">
            <TextField label={textLabel} required={true} multiline={true}
                       type="text"
                       value={forms.sanitizeValue(data.text)}
                       onChange={(event) => onChange("text", event.target.value)}
            />
        </div>
    </div>
}

export default HelpFields;
